export default __webpack_public_path__ + "static/media/PBA-terms.cecdd923.pdf";